import Reflux from "reflux";
export const get = Reflux.createAction();
export const setAction = Reflux.createAction();
